// extracted by mini-css-extract-plugin
export default {"imagemCabecalho":"ConteudoEmail_imagemCabecalho__fYawR","imagem":"ConteudoEmail_imagem__SrvB6"};